import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export const CustomerForm = ({ customerInfo, onChange }) => (
  <Card className="bg-purple-800/50 border-purple-600">
    <CardContent className="pt-6">
      <h2 className="text-2xl font-bold text-white mb-6">Customer Information</h2>
      <div className="space-y-4">
        <div>
          <Label htmlFor="name" className="text-purple-200">Full Name *</Label>
          <Input
            id="name"
            name="name"
            value={customerInfo.name}
            onChange={onChange}
            className="bg-purple-900/50 border-purple-600 text-white"
            required
            data-testid="checkout-name-input"
          />
        </div>
        <div>
          <Label htmlFor="email" className="text-purple-200">Email *</Label>
          <Input
            id="email"
            name="email"
            type="email"
            value={customerInfo.email}
            onChange={onChange}
            className="bg-purple-900/50 border-purple-600 text-white"
            required
            data-testid="checkout-email-input"
          />
        </div>
        <div>
          <Label htmlFor="phone" className="text-purple-200">Phone</Label>
          <Input
            id="phone"
            name="phone"
            type="tel"
            value={customerInfo.phone}
            onChange={onChange}
            className="bg-purple-900/50 border-purple-600 text-white"
            data-testid="checkout-phone-input"
          />
        </div>
      </div>
    </CardContent>
  </Card>
);
